import { RichTextNode } from '@/common/components/RichText/RichTextService';
import RichText from '@/common/components/RichText/RichText';

interface BlockquoteProps {
  node: RichTextNode;
}

export default function Blockquote({ node }: BlockquoteProps) {
  if (!node.content || node.content.length === 0) return null;

  return (
    <blockquote>
      <RichText content={node.content} />
    </blockquote>
  );
}
